<template>
  <div class="container-xl">
    <!-- Page title -->
    <div class="page-header d-print-none">
      <div class="row align-items-center">
        <div class="col">
          <h2 class="page-title">交易列表</h2>
        </div>
      </div>
    </div>
    <div class="row row-cards">
      <div class="col-12">
        <div class="card">
          <div class="card-body border-bottom py-3">
            <div class="d-flex">
              <div class="text-muted">
                每頁
                <div class="mx-2 d-inline-block">
                  <input
                    type="number"
                    class="form-control form-control-sm"
                    v-model.number="size"
                    size="3"
                    v-on:change="changeSize()"
                  />
                </div>
                筆
              </div>
              <!--<div class="ml-auto text-muted">
                搜尋:
                <div class="ml-2 d-inline-block">
                  <input type="text" class="form-control form-control-sm" />
                </div>
              </div>-->
            </div>
          </div>
          <div class="table-responsive">
            <table class="table card-table table-vcenter text-nowrap datatable">
              <thead>
                <tr>
                  <th class="w-1">
                    交易序號
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon-sm text-dark icon-thick"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <polyline points="6 15 12 9 18 15"></polyline>
                    </svg>
                  </th>
                  <th>商店提供編號</th>
                  <th>幣種</th>
                  <th>金額</th>
                  <th>狀態</th>
                  <th>最後更新時間</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in transactions" :key="item.id">
                  <td>
                    <span class="text-muted">{{ item.id }}</span>
                  </td>
                  <td>
                    <span class="text-muted">{{
                      item.merchantCompareOrderId
                    }}</span>
                  </td>
                  <td>
                    {{ item.currency }}
                  </td>
                  <td>
                    <span class="flag flag-country-us"></span>
                    {{ item.amount }}
                  </td>
                  <td>
                    <span
                      :class="
                        item.paymentStatus
                          ? 'badge bg-success mr-1'
                          : 'badge bg-danger mr-1'
                      "
                    ></span>
                    {{ item.paymentStatus ? "已付款" : "未付款" }}
                  </td>
                  <td>{{ item.createdAt }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer">
            <div class="row">
              <div class="col-2">
                <label class="form-check form-switch m-0">
                  測試模式
                  <input
                    class="form-check-input position-static"
                    type="checkbox"
                    :checked="testMode"
                    v-model="testMode"
                    @change="
                      getTransactionList(
                        currency,
                        order,
                        sort,
                        pagination.currentPage,
                        size,
                        startDate,
                        endDate,
                        testMode
                      )
                    "
                  />
                </label>
              </div>
              <!--<div class="col-6">
                <p class="m-0 text-muted">
                  Showing
                  <span>{{
                    size <= pagination.total ? size : pagination.total
                  }}</span>
                  of <span>{{ pagination.total }}</span> entries
                </p>
              </div>-->
              <div class="col-10">
                <ul class="pagination m-0 ms-auto float-right">
                  <li
                    class="page-item"
                    :class="{ disabled: pagination.currentPage === 1 }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="
                        getTransactionList(
                          currency,
                          order,
                          sort,
                          pagination.currentPage - 1,
                          size,
                          startDate,
                          endDate,
                          testMode
                        )
                      "
                    >
                      &laquo; Prev
                    </a>
                  </li>
                  <li
                    class="page-item"
                    v-for="page in pagination.totalPageCount"
                    :key="page"
                    :class="{ active: pagination.currentPage === page }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="
                        getTransactionList(
                          currency,
                          order,
                          sort,
                          page,
                          size,
                          startDate,
                          endDate,
                          testMode
                        )
                      "
                      >{{ page }}</a
                    >
                  </li>
                  <li
                    class="page-item"
                    :class="{
                      disabled:
                        pagination.currentPage === pagination.totalPageCount,
                    }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="
                        getTransactionList(
                          currency,
                          order,
                          sort,
                          pagination.currentPage + 1,
                          size,
                          startDate,
                          endDate,
                          testMode
                        )
                      "
                    >
                      Next &raquo;
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import moment from "moment";
export default {
  data() {
    return {
      token: "",
      transactions: [],
      currency: "",
      startDate: "",
      endDate: "",
      order: "",
      sort: "",
      page: 1,
      size: 10,
      testMode: false,
      pagination: {
        totalPageCount: 0,
        currentPage: 0,
        total: 0,
      },
    };
  },
  methods: {
    getTransactionList(
      currency = "USDT",
      order = "amount",
      sort = "desc",
      page = 1,
      size = 10,
      startDate = "",
      endDate = "",
      testMode
    ) {
      testMode = testMode ? 1 : 0;
      let api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me/order/list?currency=${currency}&order=${order}&sort=${sort}&size=${size}&page=${page}&testMode=${testMode}`;
      this.currency = currency;
      this.order = order;
      this.sort = sort;
      this.size = size;
      this.page = page;
      const vm = this;

      if (startDate !== "") {
        api += `&startDate=${startDate}`;
        this.startDate = startDate;
      }
      if (endDate !== "") {
        api += `&endDate=${endDate}`;
        this.endDate = endDate;
      }

      this.$http
        .get(api, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then(function(res) {
          if (res.data.status === "success") {
            vm.transactions = res.data.data;
            vm.pagination.currentPage = res.data.page;
            vm.pagination.total = res.data.total;
            vm.pagination.totalPageCount = Math.ceil(res.data.total / vm.size);
          }
        });
    },
    changeSize() {
      this.getTransactionList(
        this.currency,
        this.order,
        this.sort,
        this.page,
        this.size,
        this.startDate,
        this.endDate
      );
    },
  },
  created() {
    this.token = Cookies.get("USD2PayToken");
    this.getTransactionList();
  },
};
</script>

<style scoped>
.ms-auto {
  margin-left: auto !important;
}
</style>
